/*
 * @Author: your name
 * @Date: 2021-11-11 16:42:09
 * @LastEditTime: 2021-11-15 10:13:06
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://gith
 * ub.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\views\tender\tender.routing.ts
 */
import { RouterView } from "vue-router";
import { ApplyRouting } from "./apply/apply.routing";
import { MaterialRouting } from "./material/material.routing";
import { EarnestMoneyRouting } from "./earnest-money/earnest-money.routing";
import { QuoteRouting } from "./quote/quote.routing";
import { DocRouting } from "./doc/doc.routing";
import { BidManageRouting } from "./bid-manage/bid-manage.routing";

export const TenderRouting = {
  path: "/tender",
  name: "tender",
  redirect: "/tender/apply/list",
  component: RouterView,
  meta: { title: "投标管理", icon: "xiangmu" },
  children: [
    ...ApplyRouting,
    ...QuoteRouting,
    ...MaterialRouting,
    ...EarnestMoneyRouting,
    ...DocRouting,
    ...BidManageRouting,
  ],
};
